/**
 * For a `DatatableRow` the user clicks: Tessra's row draws `focus-within:focus-ring`, which lights
 * on mouse focus too and reads as a black rule above the clicked row. The controls inside keep their
 * own focus-visible rings.
 */
export const ROW_WITHOUT_FOCUS_RING = 'focus-within:ring-0 focus-within:ring-offset-0';
